<app-table
    [showPagination]="false"
    [data]="reportsListData"
    [columns]="reportsListDataColumns"
></app-table>